import { AioReplacementValues } from "./interface";

/**
 * Create new replacement values with a blank template.
 *
 * @param blankT - The blank text template
 * @returns AioReplacementValues<T>
 */
export const newReplacementValues = <T>(blankT: T): AioReplacementValues<T> => {
  return {
    airid: crypto.randomUUID(),
    texts: [blankT],
    spaceAfter: false,
    subLists: [],
  };
};
